/* Chill Country restricted-state shipping notice.
   Best-effort geo-IP: reveal the banner only when the visitor resolves to a US state/territory
   NOT on the approved list. Fails open (no banner) on any error or rate limit. Checkout shipping
   zones are the real gate. One lookup per session (cached in sessionStorage); dismissal is per-session. */
(function () {
  var el = document.querySelector('.cc-geo-notice');
  if (!el) return;

  var DISMISS_KEY = 'cc-geo-dismissed';
  var GEO_KEY = 'cc-geo-result';

  try { if (sessionStorage.getItem(DISMISS_KEY) === '1') return; } catch (e) {}

  var approved = (el.getAttribute('data-approved') || '')
    .split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);

  var NAMES = {
    AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',
    DE:'Delaware',DC:'Washington DC',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',
    IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',
    MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',
    NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',
    NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',
    RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',
    VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',
    PR:'Puerto Rico',VI:'the US Virgin Islands',GU:'Guam',AS:'American Samoa',MP:'the Northern Mariana Islands'
  };
  var TERRITORIES = ['PR','VI','GU','AS','MP'];

  function reveal(regionCode) {
    var name = NAMES[regionCode] || 'your state';
    var spans = el.querySelectorAll('.cc-geo-state');
    for (var i = 0; i < spans.length; i++) spans[i].textContent = name;
    el.hidden = false;
  }

  function evaluate(geo) {
    if (!geo) return;
    var country = (geo.country_code || '').toUpperCase();
    var region = (geo.region_code || '').toUpperCase();
    // US state / DC
    if (country === 'US' && region) {
      if (approved.indexOf(region) === -1) reveal(region);
      return;
    }
    // US territories come through as their own country code
    if (TERRITORIES.indexOf(country) !== -1) {
      if (approved.indexOf(country) === -1) reveal(country);
    }
    // Non-US, non-territory: no banner (store is US-only; checkout gates anyway).
  }

  // Wire dismiss immediately (works regardless of geo result)
  var closeBtn = el.querySelector('.cc-geo-close');
  if (closeBtn) closeBtn.addEventListener('click', function () {
    el.hidden = true;
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  });

  // QA/preview override: ?cc_geo_preview=CA forces the banner for a given state (bypasses geo-IP).
  try {
    var m = window.location.search.match(/[?&]cc_geo_preview=([A-Za-z]{2})/);
    if (m) { reveal(m[1].toUpperCase()); return; }
  } catch (e) {}

  // Cached result for this session?
  try {
    var cached = sessionStorage.getItem(GEO_KEY);
    if (cached) { evaluate(JSON.parse(cached)); return; }
  } catch (e) {}

  // Fetch best-effort geo (3s timeout, fail open)
  var done = false;
  var ctrl = ('AbortController' in window) ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 3000);
  fetch('https://ipwho.is/', ctrl ? { signal: ctrl.signal } : undefined)
    .then(function (r) { return r.json(); })
    .then(function (geo) {
      done = true; clearTimeout(timer);
      if (!geo || geo.success === false) return;
      var slim = { country_code: geo.country_code, region_code: geo.region_code };
      try { sessionStorage.setItem(GEO_KEY, JSON.stringify(slim)); } catch (e) {}
      evaluate(slim);
    })
    .catch(function () { clearTimeout(timer); /* fail open: no banner */ });
})();
